<template ref="searchBox">
    <div class="input-group mb-3">
        <input 
            type="text" 
            class="form-control" 
            placeholder="คำค้น" 
            aria-label="คำค้น" 
            aria-describedby="basic-addon2" 
            v-model="searchKeyword"
            @keyup.enter="searchButtonClick()"
        >
        <div class="input-group-append">
            <button class="btn btn-outline-secondary general-search" type="button" @click="searchButtonClick()">ค้นหา</button>
        </div>
    </div>
</template>

<script>
export default {
        name:'searchBox',
        props:['item'],
        searchKeyword:'',
        data() {
            return {
                searchKeyword:'',
                searchButton:{},
            }
        },
        mounted() {
            //console.log('Component mounted.')            
        },
        created(){
     
        },
        methods:{                 
            searchButtonClick(){
                this.$emit('searchButtonClick', this.searchKeyword);
            }
        },        
    }
</script>